import React from 'react';
import { Item, Segment } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { getImageUrl } from "../../../utils/images";
import type {
  SemanticSIZES,
} from "semantic-ui-react";

interface ItemLink {
  '@id': string;
}

interface ViewItem {
  image: string;
  imageSize: SemanticSIZES;
  header: string;
  link?: ItemLink[];
  meta?: string;
  description: string;
  extra?: string;
}

interface ItemsViewData {
  items?: ViewItem[];
}

interface ItemsViewProps {
  data: ItemsViewData;
}

const ItemsView = ({ data = {} }: ItemsViewProps) => {
  const { items = [] } = data;
  
  if (!items.length) return null;

  // using destructured Item instead of importing Item submodules to avoid circular imports
  const { Group, Image, Content, Header, Description, Meta, Extra } = Item;

  return (
    <Segment basic>
      <Group>
        {items.map((item, index) => {
          const imageUrl = getImageUrl(item.image);
          const linkUrl = item.link?.[0]?.['@id']
            ? flattenToAppURL(item.link[0]['@id'])
            : null;
          const headerProps = linkUrl
            ? { as: 'a', href: linkUrl }
            : {};

          return (
            <Item key={index}>
              {imageUrl && (
                <Image size={item.imageSize || 'tiny'} src={imageUrl} />
              )}
              <Content>
                <Header 
                  {...headerProps}
                >
                  {item.header}
                </Header>
                {item.meta && <Meta>{item.meta}</Meta>}
                <Description>{item.description}</Description>
                {item.extra && <Extra>{item.extra}</Extra>}
              </Content>
            </Item>
          );
        })}
      </Group>
    </Segment>
  );
};

export default ItemsView;
